import { render } from "./UnAssignedIssues.vue?vue&type=template&id=7fd2dd4a&scoped=true"
import script from "./UnAssignedIssues.vue?vue&type=script&lang=js"
export * from "./UnAssignedIssues.vue?vue&type=script&lang=js"

import "./UnAssignedIssues.vue?vue&type=style&index=0&id=7fd2dd4a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+comp_4cebc095a9b5bcc882fa23a41973ce86/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7fd2dd4a"]])

export default __exports__